var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3333 18.0003V27.3337C17.3333 27.6873 17.1929 28.0264 16.9428 28.2765C16.6928 28.5265 16.3536 28.667 16 28.667C15.6464 28.667 15.3072 28.5265 15.0572 28.2765C14.8071 28.0264 14.6667 27.6873 14.6667 27.3337V18.0003H5.33333C4.97971 18.0003 4.64057 17.8598 4.39052 17.6098C4.14048 17.3598 4 17.0206 4 16.667C4 16.3134 4.14048 15.9742 4.39052 15.7242C4.64057 15.4741 4.97971 15.3337 5.33333 15.3337H14.6667V6.00033C14.6667 5.6467 14.8071 5.30756 15.0572 5.05752C15.3072 4.80747 15.6464 4.66699 16 4.66699C16.3536 4.66699 16.6928 4.80747 16.9428 5.05752C17.1929 5.30756 17.3333 5.6467 17.3333 6.00033V15.3337H26.6667C27.0203 15.3337 27.3594 15.4741 27.6095 15.7242C27.8595 15.9742 28 16.3134 28 16.667C28 17.0206 27.8595 17.3598 27.6095 17.6098C27.3594 17.8598 27.0203 18.0003 26.6667 18.0003H17.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconWhite);
export default __webpack_public_path__ + "static/media/plus-icon-white.1853b7e4f7a6f77774be940f160257e0.svg";
export { ForwardRef as ReactComponent };